<template>
    <component :is="type" v-bind="linkProps(to)" @click="onClick">
        <slot />
    </component>
</template>

<script>
import { isExternal } from "@/utils/validate";

export default {
    props: {
        to: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    computed: {
        // 根据url或者路由配置来判断是否为外链
        isExternal() {
            return isExternal(this.to) || (this.item && this.item.meta && this.item.meta.isExternal);
        },
        type() {
            if (this.isExternal) {
                return "a";
            }
            // return "router-link";
            return "div";
        },
    },
    methods: {
        linkProps(to) {
            if (this.isExternal) {
                let $to = to;
                if (this.item && this.item.redirect !== "noRedirect") {
                    $to = this.item.redirect;
                }
                return {
                    href: $to,
                    target: "_blank",
                    rel: "noopener",
                };
            }
            return {
                to: to,
            };
        },

        onClick() {
            if (this.isExternal) {
                return;
            }
            const { fullPath } = this.$route;
            if (fullPath === this.to) {
                this.$router.replace({
                    path: "/redirect" + fullPath,
                });
            } else {
                this.$router.push({
                    path: this.to,
                });
            }
        },
    },
};
</script>
